import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Redirect, Route, Switch } from "react-router";
import SearchProperty from "../../component/TenantContract/SearchProperty";
import PropertyList from "../../component/TenantContract/PropertyList";
import TenantContract from "../TenantContract";
import TenantContextWrapper from "@eres/ejari-core/contexts/TenantContext";
import PropertyDetails from "../../component/TenantContract/PropertyDetails";
import LeaseDetails from "./LeaseDetails";
import TenantRegistration from "./Registration/TenantRegistration";
import { TenantCoOccupants } from "../ManageCoOccupant";
import ManagePets from "../ManagePets";

class TenantEjariServices extends Component<RoutedViewProps> {
	render() {
		const pp = this.props.match.url;
		return <TenantContextWrapper>
			<Switch>
				<Route path={ pp + "/lease/details" } component={ LeaseDetails }/>
				<Route path={ pp + "/property/search" } component={ SearchProperty }/>
				<Route path={ pp + "/property/list" } component={ PropertyList }/>
				<Route path={ pp + "/property/details" } component={ PropertyDetails }/>
				<Route path={ pp + "/contract" } component={ TenantContract }/>
				<Route path={ pp + "/registration" } component={ TenantRegistration }/>
				<Route path={ pp + "/lease/cooccupants" } component={ TenantCoOccupants }/>
				<Route path={ pp + "/lease/pets" } component={ ManagePets }/>
				{/*<Route path={ pp + "/lease/mollakServices" } component={ ManagePets }/>*/}
				<Route path={ pp } exact={ true }>
					<Redirect to={ pp + "/property/search" }/>
				</Route>
			</Switch>
		</TenantContextWrapper>;
	}
}

export default TenantEjariServices;
